import { ButtonBase } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import clsx from "clsx";
import { palette } from "../../theme/palette";

const useStyles = makeStyles({
  button: {
    color: palette.typography.white.solid,
    fontSize: "11px",
    padding: "2px 4px",
    border: "0.063rem solid white",
    borderRadius: "4px",
    margin: "5px",
    letterSpacing: "0.0025em",
    cursor: "pointer",
  },
  buttonActive: {
    color: palette.typography.black.solid,
    background: palette.typography.white.solid,
  },
  disabled: {
    border: `0.063rem solid ${palette.typography.white.disabled}`,
    color: palette.typography.white.disabled,
  },
  activeDisabled: {
    color: palette.typography.black.disabled,
    background: palette.typography.white.disabled,
  },
});

export const FilterButton = ({
  children,
  active,
  onClick,
  disabled = false,
}) => {
  const styles = useStyles();

  return (
    <ButtonBase
      className={clsx(
        styles.button,
        active && styles.buttonActive,
        disabled && styles.disabled,
        active && disabled && styles.activeDisabled
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </ButtonBase>
  );
};
